import _extends from '@babel/runtime-corejs3/helpers/esm/extends';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/esm/objectWithoutProperties';
import _bindInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/bind';
import React from 'react';
import PropTypes from 'prop-types';
import { List } from '@webteam/list';
import classnames from 'classnames/bind';
import localNames from '../index.pcss.js';
import CheckboxManager from './checkbox-manager.js';

var cn = _bindInstanceProperty(classnames).call(classnames, localNames);

var CheckboxList = function CheckboxList(_ref) {
  var mode = _ref.mode,
      size = _ref.size,
      theme = _ref.theme,
      disabled = _ref.disabled,
      children = _ref.children,
      onChange = _ref.onChange,
      value = _ref.value,
      defaultValue = _ref.defaultValue,
      error = _ref.error,
      className = _ref.className,
      style = _ref.style,
      restProps = _objectWithoutProperties(_ref, ["mode", "size", "theme", "disabled", "children", "onChange", "value", "defaultValue", "error", "className", "style"]);

  return React.createElement(CheckboxManager, {
    theme: theme,
    defaultValue: defaultValue
    /* error={Boolean(error)}  Don't show error on every checkbox */
    ,
    onChange: onChange,
    value: value,
    disabled: disabled,
    size: size
  }, React.createElement("div", {
    className: className,
    style: style
  }, error && typeof error !== 'boolean' && React.createElement("div", {
    className: cn('wt-checkbox__error-message', 'wt-checkbox__error-message_list', 'wt-text-3')
  }, error), React.createElement(List, _extends({
    tag: 'div',
    size: size,
    mode: mode,
    disabled: disabled,
    theme: theme
  }, restProps), children)));
};

CheckboxList.propTypes = {
  mode: PropTypes.oneOf(['cell', 'nude']),
  size: PropTypes.oneOf(['m', 's', 'xs']),
  onChange: PropTypes.func,
  value: PropTypes.array,
  defaultValue: PropTypes.array,
  error: PropTypes.oneOfType([PropTypes.bool, PropTypes.node]),
  theme: PropTypes.oneOf(['light', 'dark']),
  disabled: PropTypes.bool
};

export { CheckboxList as default };
